import * as R from 'ramda';

export const getPathList = (tree) => {
  const pathList = [];
  // 递归获取权限name
  function setPathList(tree) {
    R.map((item) => {
      if (R.is(Array, item.children) && R.length(item.children) > 0) {
        setPathList(item.children);
      }
      pathList.push(item);
      return '';
    }, tree);
  }
  setPathList(tree);
  return pathList;
};



// WEBPACK FOOTER //
// ./src/utils/rbac/index.js